import React, { useState, useMemo } from 'react';
import { Button, Icon } from '@kajabi/sage-react';
import { useConfigContext } from 'common/components/CopyMagic/contexts';
import PromptSuggestionsItem from '../PromptSuggestionsItem/PromptSuggestionsItem';
import './style.scss';

const MAX_SUGGESTIONS = 3;

const PromptSuggestions = () => {
  const { suggestions: suggestionsList } = useConfigContext();
  const [expanded, setExpanded] = useState(false);
  const shortSuggestionsList = useMemo(
    () => (suggestionsList || []).slice(0, MAX_SUGGESTIONS),
    [suggestionsList],
  );

  if (!suggestionsList || !suggestionsList.length) {
    return null;
  }

  const showButton = suggestionsList.length > MAX_SUGGESTIONS;
  const suggestions = expanded ? suggestionsList : shortSuggestionsList;

  return (
    <div className="copy-magic-conversation-assistant-suggestions">
      <p className="copy-magic-conversation-assistant-suggestions__title">Suggestions</p>
      {suggestions.map((promptData) => (
        <PromptSuggestionsItem promptData={promptData.attributes.messages} key={promptData.id} />
      ))}
      {showButton && (
        <Button
          className="copy-magic-conversation-assistant-suggestions__expand_button"
          color={Button.COLORS.SECONDARY}
          onClick={() => setExpanded(!expanded)}
          icon={expanded ? Icon.ICONS.UP_SMALL : Icon.ICONS.DOWN_SMALL}
          subtle
        >
          {expanded ? 'See less' : 'See more'}
        </Button>
      )}
    </div>
  );
};

export default PromptSuggestions;
